// material-ui
import { List } from '@mui/material';

import HeaderMenuItem from 'components/HeaderMenuItem';

// assets
import CustomerServiceOutlined from '@ant-design/icons/CustomerServiceOutlined';
import { BarsOutlined } from '@ant-design/icons';

type Props = Readonly<{
  selectedIndex: number;
  handleListItemClick: (_: React.MouseEvent<HTMLDivElement>, index: number, route?: string) => void;
}>;

export default function SettingTab({ selectedIndex, handleListItemClick }: Props) {
  return (
    <List component="nav" sx={{ p: 0, '& .MuiListItemIcon-root': { minWidth: 32 } }}>
      <HeaderMenuItem
        icon={<BarsOutlined />}
        onClick={(e) => handleListItemClick(e, 1, '/support/faqs')}
        selected={selectedIndex === 1}
        titleId="faqs"
      />

      <HeaderMenuItem
        icon={<CustomerServiceOutlined />}
        onClick={(e) => handleListItemClick(e, 2, '/support/help')}
        selected={selectedIndex === 2}
        titleId="help"
      />
    </List>
  );
}
